import { takeLatest, put } from "redux-saga/effects";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  requestSaga
} from "../utils/helpers";

const initialState = {
  hedgeEscrows: [],
  isLoading: false
};

export default function hedgeEscrowReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case HEDGE_ESCROW_UPDATE.success:
      ToastSuccess("Save Successful");

      return defaultReturn(state);

    case HEDGE_ESCROW_UPDATE.error:
      ToastError("Save Unsuccessful");

      return defaultReturn(state);

    case HEDGE_ESCROWS_GET_BY_HEDGE_ID.success:
      return defaultReturn(state, payload.data, "hedgeEscrows");

    case HEDGE_ESCROWS_GET_BY_HEDGE_ID.error:
      ToastError("Unable to Fetch Hedge Escrows");

      return defaultReturn(state);

    case HEDGE_ESCROW_IS_LOADING.value:
      return defaultReturn(state, payload.isLoading, "isLoading");

    default:
      return state;
  }
}

export function* hedgeEscrowSaga() {
  yield takeLatest(HEDGE_ESCROW_UPDATE.value, hedgeEscrowUpdateSaga);
  yield takeLatest(HEDGE_ESCROWS_GET_BY_HEDGE_ID.value, getHedgeEscrowsByHedgeIdSaga);
  yield takeLatest(HEDGE_ESCROWS_RECALC_FULL.value, recalcHedgeEscrowsByHedgeIdFullSaga);
}

/*
 * IS_LOADING
 * payload: {isLoading:boolean}
 */
export const HEDGE_ESCROW_IS_LOADING = {
  setHedgeEscrowIsLoading: payload => ({ type: "HEDGE_ESCROW_IS_LOADING", payload })
};

/*
 * UPDATE_HEDGE_ESCROW
 * payload: {hedgeEscrow}
 */
export const HEDGE_ESCROW_UPDATE = generateDefaultActions("HEDGE_ESCROW_UPDATE");
export const hedgeEscrowUpdate = payload => makePayload(HEDGE_ESCROW_UPDATE.value, payload);
function* hedgeEscrowUpdateSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const { hedgeEscrow } = payload;
  const url = `/hedgeEscrow/${hedgeEscrow.id}`;

  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: true }));
  yield requestSaga(HEDGE_ESCROW_UPDATE, url, "PUT", hedgeEscrow);
  if (callback) {
    callback();
  }
  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: false }));
}

/*
 * HEDGE_ESCROWS_GET_BY_HEDGE_ID
 * payload: {hedgeId}
 */
export const HEDGE_ESCROWS_GET_BY_HEDGE_ID = generateDefaultActions("HEDGE_ESCROWS_GET_BY_HEDGE_ID");
export const getHedgeEscrowsByHedgeId = payload => makePayload(HEDGE_ESCROWS_GET_BY_HEDGE_ID.value, payload);
function* getHedgeEscrowsByHedgeIdSaga(payload) {
  const url = `/hedgeEscrow/hedge/${payload.hedgeId}`;

  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: true }));
  yield requestSaga(HEDGE_ESCROWS_GET_BY_HEDGE_ID, url, "GET");
  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: false }));
}

/*
 * HEDGE_ESCROWS_RECALC_FULL
 * payload: {hedge}
 */
export const HEDGE_ESCROWS_RECALC_FULL = generateDefaultActions("HEDGE_ESCROWS_RECALC_FULL");
export const recalcHedgeEscrowsByHedgeIdFull = payload => makePayload(HEDGE_ESCROWS_RECALC_FULL.value, payload);
function* recalcHedgeEscrowsByHedgeIdFullSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;

  const url = `/hedgeEscrow/hedge/${payload.hedgeId}/recalcFull`;
  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: true }));
  yield requestSaga(HEDGE_ESCROWS_RECALC_FULL, url, "GET");
  if (callback) {
    callback();
  }
  yield put(HEDGE_ESCROW_IS_LOADING.setHedgeEscrowIsLoading({ isLoading: false }));
}

